/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class PointOfSaleSettings extends DaoModel {
  constructor(guid, pointOfSale, minWeightFullPortionRate, maxPriceHalfPortionRate, productBoostDays) {
    super(guid);
    this.pointOfSale = pointOfSale || '';
    this.minWeightFullPortionRate = minWeightFullPortionRate || 0.0;
    this.maxPriceHalfPortionRate = maxPriceHalfPortionRate || 1.0;
    this.productBoostDays = productBoostDays || 7;
  }

  static toInstance(props = {}) {
    return new PointOfSaleSettings(props.guid, props.point_of_sale,
      props.min_weight_full_portion_rate, props.max_price_half_portion_rate,
      props.product_boost_days);
  }
}
